import React, { useEffect, useState } from 'react';
import { IoIosCloseCircle } from 'react-icons/io';
import defaultImg from "../../assets/images/product/defaultImg.svg";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { fetchBanner } from '../../Redux/Reducers/BannerReducer';
import toast from 'react-hot-toast';
import { uploadImagecertifates } from '../../Redux/Actions/Action';
import { usePermissions } from '../../context/AuthContext';
import { Tooltip } from '@mui/material';

function CourseBanner() {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const banners = useSelector(state => state?.BannerReducer?.banner);
    const webBanner = banners?.[1]?.topBanner;
    const mobileBanner = banners?.[0]?.topBanner;
    const [webImages, setWebImages] = useState(Array(6).fill(null));
    const [mobileImages, setMobileImages] = useState(Array(6).fill(null));
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("web");

    useEffect(() => {
        dispatch(fetchBanner());
    }, [dispatch]);

    useEffect(() => {
        if (webBanner) {
            setWebImages([...webBanner, ...Array(6 - webBanner.length).fill(null)]);
        }
        if (mobileBanner) {
            setMobileImages([...mobileBanner, ...Array(6 - mobileBanner.length).fill(null)]);
        }
    }, [webBanner, mobileBanner]);

    const handleInputChange = async (event) => {
        setLoading(true);
        const files = Array.from(event.target.files);
        const updatedImages = activeTab === "web" ? [...webImages] : [...mobileImages];

        for (let file of files) {
            const uploadedImageUrl = await dispatch(uploadImagecertifates(file));
            const emptyIndex = updatedImages.indexOf(null);
            if (emptyIndex !== -1) {
                updatedImages[emptyIndex] = uploadedImageUrl;
            }
        }

        setLoading(false);
        activeTab === "web" ? setWebImages(updatedImages) : setMobileImages(updatedImages);
    };

    const handleRemoveImage = (index) => {
        if (activeTab === "web") {
            setWebImages(webImages.map((img, imgIndex) => (imgIndex === index ? null : img)));
        } else {
            setMobileImages(mobileImages.map((img, imgIndex) => (imgIndex === index ? null : img)));
        }
    };

    const handleSave = async () => {
        const bannerType = activeTab === "web" ? "forWeb" : "forMobile";
        const selectedImages = activeTab === "web" ? webImages : mobileImages;

        const payload = {
            topBanner: selectedImages.filter(img => img !== null),
            bannerType,
        };

        try {
            const token = localStorage.getItem("vedhvidhi-admin-token");

            const response = await axios.post(
                `${process.env.REACT_APP_BASEURL}/admin/banner`,
                payload,
                {
                    headers: {
                        'Authorization': `${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );

            if (response.data.success) {
                toast.success(`Banner updated successfully for ${bannerType}!`);
            } else {
                toast.error('Failed to update banner');
            }
        } catch (error) {
            console.error('Error updating banner:', error.response?.data || error);
            toast.error(error.response?.data?.message || 'Error updating banner');
        }
    };

    return (
        <>
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold">Course Banner <span style={{ color: "red" }}>*</span></h6>
            </div>

            <div className="d-flex mb-3">
                <button
                    className={`btn ${activeTab === "web" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => setActiveTab("web")}
                >
                    Web View
                </button>
                <button
                    className={`btn ms-2 ${activeTab === "mobile" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => setActiveTab("mobile")}
                >
                    Mobile View
                </button>
            </div>

            <div className="card-body">
                <form>
                    <div className="row g-3 align-items-center">
                        <div className="col-md-12">
                            <small className="d-block text-muted mb-2">Select up to 6 images only.</small>

                            <div id='create-token' className={`dropzone ${!can('course_banners:add') && 'disabled'}`}>
                                <div className='dz-message d-flex align-items-center justify-content-center flex-column'>
                                    <i className="fa fa-picture-o m-0" aria-hidden="true"></i>
                                    <h5 style={{ fontSize: '17px', color: '#7258db', fontWeight: '600', marginTop: '8px' }}>
                                        {loading ? "Uploading..." : "Upload a file"}
                                    </h5>
                                    <h6 style={{ fontSize: '14px' }}>PNG, JPG, WEBP, SVG...</h6>
                                </div>
                                <input
                                    id='filesize'
                                    onChange={handleInputChange}
                                    name="file"
                                    type="file"
                                    accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff, .mp4, .webm, .mp3, .wav, .ogg, .glb"
                                    multiple
                                    disabled={!can('course_banners:add')}
                                />
                            </div>
                        </div>

                        {(activeTab === "web" ? webImages : mobileImages)?.map((image, index) => (
                            <div className='col-lg-2 col-md-4' key={index}>
                                <div className='position-relative border p-3' style={{ borderRadius: "0.95rem" }}>
                                    {image ? (
                                        <>
                                            <img className='img-fluid' src={image} alt={`uploaded-img-${index}`} />
                                            {can('course_banners:delete') && (
                                                <Tooltip title="Remove Image">
                                                    <button
                                                        type="button"
                                                        className='position-absolute end-0 top-0 padding-0 pt-1 bg-transparent border-0'
                                                        onClick={() => handleRemoveImage(index)}
                                                    >
                                                        <IoIosCloseCircle style={{ fontSize: '26px', color: "#727070" }} />
                                                    </button>
                                                </Tooltip>
                                            )}
                                        </>
                                    ) : (
                                        <img className='img-fluid' src={defaultImg} alt="default" />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {can('course_banners:edit') && (
                        <div className="col-12 mt-4">
                            <button type="button" className="btn btn-primary text-uppercase px-5" onClick={handleSave}>
                                SAVE
                            </button>
                        </div>
                    )}
                </form>
            </div>
        </>
    );
}

export default CourseBanner;